export enum JobSalaryTypeEnum {
    PerYear = 10,
    PerHour = 20,
}

export enum JobSalaryTypeName {
    PerYear = "Per Year",
    PerHour = "Per Hour",
}
